import { borderRadius, ButtonGroup } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;
  padding: 20px;
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  border-radius: 12px;
  border: 1px solid var(--border-soft);
  background: var(--background-soft);
  height: 40px;

  [data-button-group-item] {
    ${borderRadius.r2};
    text-transform: none;
  }

  margin-bottom: 24px;
`;

export const LoaderWrapper = styled.div`
  padding-top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
